import { computed, inject } from '@angular/core';
import { AuthSessionStore } from '@indutrust/auth-data';
import { RouterStore } from '@indutrust/shared-data';
import { signalStore, withComputed } from '@ngrx/signals';

/**
 * Root application signal store managing app initialization state.
 *
 * Coordinates application readiness by composing multiple initialization signals.
 *
 * Provided in `root`. Depends on {@link RouterStore} and {@link AuthSessionStore}.
 */
export const AppStore = signalStore(
  { providedIn: 'root' },
  withComputed(
    (
      _,
      routerStore = inject(RouterStore),
      authStore = inject(AuthSessionStore)
    ) => ({
      isAppInitialized: computed(
        () =>
          routerStore.firstNavigationCompleted() &&
          authStore.authenticationInitialized()
      ),
    })
  )
);
